<div class="w-full p-2">
  <div class="bg-light-surface dark:bg-dark-surface rounded-lg shadow-lg">
    <!-- Header -->
    <div class="border-b border-light-border dark:border-dark-border px-6 py-4">
      <h1 class="titulo">Pruebas Automatizadas</h1>
      <p class="normal">Gestión y ejecución de pruebas automatizadas para chatbots</p>
    </div>

    <!-- Column Descriptions -->
    <div class="px-6 py-4 bg-blue-50 dark:bg-blue-900/20">
      <h2 class="text-lg font-semibold text-blue-900 dark:text-blue-200 mb-3">Columnas Esperadas</h2>
      <div class="flex flex-wrap gap-2">
        @for (column of columnDescriptions; track column) {
          <button
            type="button"
            class="inline-flex items-center px-3 py-2 bg-blue-100 dark:bg-blue-800 text-blue-800 dark:text-blue-200 rounded-full text-sm font-medium hover:bg-blue-200 dark:hover:bg-blue-700 transition-colors cursor-help border-none"
            [matTooltip]="column.value"
            matTooltipPosition="above">
            <span class="font-mono">{{ column.key }}</span>
          </button>
        }
      </div>
    </div>



    <!-- File Upload Section -->
    <div class="px-6 py-6">
      <label for="file-upload" class="block cursor-pointer">
        <div class="border-2 border-dashed border-light-border dark:border-dark-border rounded-lg p-6 hover:border-indigo-500 dark:hover:border-indigo-400 transition-colors">
          <div class="text-center">
            <lucide-icon [img]="Upload" class="mx-auto h-12 w-12 text-light-text-secondary dark:text-dark-text-secondary"></lucide-icon>
            <div class="mt-4">
              <span class="mt-2 block text-sm font-medium text-light-text-primary dark:text-dark-text-primary">
                Seleccione un archivo CSV para cargar
              </span>
              <p class="normal">
                CSV hasta 10MB
              </p>
            </div>
          </div>
        </div>
        <input id="file-upload" name="file-upload" type="file" class="sr-only" accept=".csv" (change)="onFileSelect($event)">
      </label>

      <!-- Action Buttons -->
      <div class="mt-4 flex flex-wrap gap-3">
        <button
          type="button"
          (click)="downloadTemplate()"
          class="inline-flex items-center px-4 py-2 border border-green-300 text-sm font-medium rounded-md text-green-700 bg-green-50 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
          <lucide-icon [img]="Download" class="-ml-1 mr-2 h-4 w-4"></lucide-icon>
          Descargar Plantilla CSV
        </button>

        @if (showPreview) {
          <button
            type="button"
            (click)="clearPreview()"
            class="inline-flex items-center px-4 py-2 border border-light-border dark:border-dark-border text-sm font-medium rounded-md text-light-text-primary dark:text-dark-text-primary bg-light-surface dark:bg-dark-surface hover:bg-light-surface-hover dark:hover:bg-dark-surface-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <lucide-icon [img]="X" class="ml-1 mr-2 h-4 w-4"></lucide-icon>
            Limpiar Vista Previa
          </button>
        }
      </div>
    </div>

    <!-- Preview Section -->
    @if (showPreview) {
      <div class="pb-6">
        <app-csv-preview
          [csvRecords]="csvRecords"
          [fileName]="fileName">
        </app-csv-preview>
      </div>
    }
  </div>
</div>
